/*
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-02 16:45:48
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\ultrasonic.js
 */
import request from '@/utils/request'
import config from '@/utils/config'
import {handleUrlEncode} from "@/utils/urlutil";


/**
 * 后台获取超人圈视频模块配置信息
 * @param data
 * @returns {*}
 */
export function getForumConfig(data) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/AppConfig',
    method: 'get',
    data
  })
}

/**
 * 后台更新超人圈视频模块配置信息
 * @param data
 * @returns {*}
 */
export function updateForumConfig(data) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/AppConfig',
    method: 'post',
    data
  })
}

/**
 * 获取所有超人圈
 *
 * @param {*} params
 */
export function getAllForumsList(params) {
  let url = `${config.API_ADMIN}/Api/V1/AdminForums/Forum/List?`
  url = handleUrlEncode(url,params)
  return request({
    url: url,
    method: 'get',
  })
}

/**
 * 发表超人圈
 *
 * @param {*} data
 */
export function addForums(data) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/Add',
    method: 'post',
    data
  })
}

/**
 * 删除/恢复超人圈
 *
 * @param {*} params
 */
export function deleteOrBackForums(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/DeleteOrBack',
    method: 'delete',
    params
  })
}

/**
 * 设置超人圈帖子的状态
 *
 * @param {*} params
 */
export function setForums(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/Update',
    method: 'post',
    data: params
  })
}

/**
 * 获取所有帖子类型
 *
 * @param {*} params
 */
export function getForumCategoryList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumCategory/List',
    method: 'get',
    params
  })
}

/**
 * 新增帖子类型
 *
 * @param {*} data
 */
export function addForumCategory(data) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumCategory/Add',
    method: 'post',
    data
  })
}

/**
 * 新增帖子文件
 */
export function addForumFile(data){
  return request({
    url:config.API_ADMIN+'/Api/V1/AdminForums/File/Add',
    method:'post',
    data
  })
}

/**
 * 修改帖子类型
 *
 * @param {*} data
 */
export function updateForumCategory(data) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumCategory/Update',
    method: 'post',
    data
  })
}

/**
 * 删除/恢复帖子类型
 *
 * @param {*} params
 */
export function deleteOrBackForumCategory(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumCategory/DeleteOrBack',
    method: 'delete',
    params
  })
}

/**
 * 获取所有超人圈群组列表
 *
 * @param {*} params
 */
export function getAllForumGroupList(params) {
  let url = `${config.API_ADMIN}/Api/V1/AdminForums/ForumGroup/List?`
  url = handleUrlEncode(url,params)
  return request({
    url: url,
    method: 'get',
  })
}

/**
 * 添加超人圈群组
 *
 * @param {*} data
 */
export function addForumGroup(data) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroup/Add',
    method: 'post',
    data
  })
}

/**
 * 删除/恢复超人圈群组
 *
 * @param {*} params
 */
export function deleteOrBackForumGroup(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroup/DeleteOrBack',
    method: 'delete',
    params
  })
}

/**
 * 设置超人圈群组
 *
 * @param {*} params
 */
export function setForumGroup(params) {
  return request({
    url: config.API_MEDICAL + '/Api/V1/AdminForumGroups/ForumGroup/SetOrCancel',
    method: 'post',
    params
  })
}

/**
 * 更新群组
 *
 * @param {*} params
 */
export function updateForumGroup(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroup/Update',
    method: 'post',
    data:params
  })
}

/**
 * 获取标签
 *
 */
export function getForumGroupTaps(params){
  let url = `${config.API_ADMIN}/Api/V1/AdminForums/ForumGroupTag/List?`
  url = handleUrlEncode(url,params)
    return request({
      url: url,
      method:'get',
    })
}

/**
 * 新增标签
 */
export function addTag(params){
  return request({
    url:config.API_ADMIN+'/Api/V1/AdminForums/ForumGroupTag/Add',
    method:'post',
    data:params
  })
}

/**
 * 删除/恢复标签
 */
export function deleteOrBackForumTag(params){
  return request({
    url:config.API_ADMIN+'/Api/V1/AdminForums/ForunGroupTag/DeleteOrBack',
    method:'delete',
    params
  })
}
